import { constants } from './constants'

type PaymentRedirect = {
    redirect_url?: string
    uuid?: string
}

/**
 * A payment result belongs to the attempt currently in the store.
 * Unstamped results stay valid for older callers. A stamped result with
 * no current attempt is a response that arrived after the attempt was cleared.
 */
export const isPaymentResultForAttempt = (
    resultUuid?: string,
    attemptUuid?: string
) => {
    if (!resultUuid) return true
    if (!attemptUuid) return false
    return resultUuid === attemptUuid
}

export const shouldOpenPaymentRedirect = (
    response: PaymentRedirect | null | undefined,
    attemptUuid: string | undefined,
    attemptAbandoned: boolean
) => {
    if (attemptAbandoned || !response?.redirect_url) return false
    return isPaymentResultForAttempt(response.uuid, attemptUuid)
}

export const paymentStartEvent = () => ({
    category: constants.ANALYTICS.CATEGORIES.PAYMENT,
    action: constants.ANALYTICS.ACTIONS.MOBILE_MONEY_PAYMENT,
    name: constants.ANALYTICS.NAMES.PAYMENT_START
})

export const paymentWaitExitEvent = () => ({
    category: constants.ANALYTICS.CATEGORIES.PAYMENT,
    action: constants.ANALYTICS.ACTIONS.MOBILE_MONEY_PAYMENT,
    name: `${constants.ANALYTICS.NAMES.PAYMENT_EXITED}-waiting`
})
